<template>
  <div>
    <div v-if="!loading">
      <app-form v-bind:parentObject="{
        data: this.formData,
        searchnew: this.search,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }" v-on:input="formData[0] = $event" v-on:new="createHandler" v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm" v-on:error="errorHandler" />

      <div v-if="isErr">
        <app-error v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }" v-on:closeError="isErr = $event" />
      </div>

      <div v-if="isConfirm">
        <app-confirm v-bind:parentObject="{
          pageTitleValue: this.pageTitleValue,
          isConfirm: this.isConfirm,
        }" v-on:confirm="deleteHandler($event)" v-on:cancelConfirm="isConfirm = !isConfirm" />
      </div>
    </div>
  </div>
</template>

<script>

import MainForm from "../../../components/payroll/arrearstransaction/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": MainForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('arrearsexercise.editarrearstransaction'),
      pageTitleValue: "",
      formData: {
        staffid: null,
        bpexerciseid: null,
        bpexercisepoid: null,
        payitemid: null,
        quantity: null,
        oldamt: null,
        newamt: null,
        diffamt: null,
        crcyid: null,
        topay: false,
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      errMsg: "",
      confirmMsg: "",
      isErr: false,
      loading: true,
      editMode: true,
      isConfirm: false,
    };
  },

  methods: {
    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      var payload = this.formData[0];

      this.$store.dispatch('put', { url: "/arrearstransaction/" + vm.id, payload: payload })
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "arrearstransactionlist", params: { search: this.search } });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    cancelHandler() {
      this.$router.push({ name: "arrearstransactionlist" });
    },

    deleteHandler($event) {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.isConfirm = !this.isConfirm;

      if ($event) {
        this.$store.dispatch('delete', {
          url:
            "/staffbankaccount/" +
            this.id +
            "/" +
            this.formData[0].userid
        })
          .then((res) => {
            if (res.data.error) {
              vm.isErr = !vm.isErr;
              vm.errMsg = res.data.error;
            } else {
              this.$router.push({ name: "arrearstransactionlist" });
            }
          })
          .catch((err) => {
            vm.isErr = !vm.isErr;
            vm.errMsg = err;
          });
      }
    },

    createHandler() {
      this.$router.push({ name: "arrearstransactionnew" });
    },

    loadArrearsTransactionHandler() {
      const vm = this;

      this.$store.dispatch('get', { url: "/arrearstransaction/" + vm.id })
        .then((res) => {
          if (res.status == 200) {
            vm.formData = res.data.rec;

            // vm.pageTitleValue = vm.formData[0].accountname;

            if (vm.formData.topay == "Y") {
              vm.formData.topay = true;
            } else {
              vm.formData.topay = false;
            }
            if (vm.formData.posted == "Y") {
              vm.formData.posted = true;
            } else {
              vm.formData.posted = false;
            }

            vm.formData.id = res.data.rec.id;
            vm.formData.userid = vm.$store.getters.userId;

            // console.log('idde',vm.formData.iddetails)

            vm.loading = !vm.loading;
          } else {
            vm.isErr = !vm.isErr;
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },
  },

  mounted() {
    this.loadArrearsTransactionHandler();
  },
};
</script>